import {expand} from '@emmetio/expand-abbreviation'
export const emmetExpand = expand